import React from 'react'

function UpdateAvatarLogo({
  closeModal,
  editCard,
  avatarPreview,
  avatarFile,
  logoPreview,
  logoFile,
  uploading,
  handleAvatarChange,
  handleLogoChange,
  message,
  error,
  handleSaveEdits,
  setCompany,
  company,
  setWebsiteUrl,
  websiteUrl
}) {
  const hasChanges =
    avatarFile ||
    logoFile ||
    company.trim() !== (editCard?.business || '').trim() ||
    websiteUrl.trim() !== (editCard?.website_url || '').trim();

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '16px',
          width: '92%',
          maxWidth: '540px',
          maxHeight: '92vh',
          overflowY: 'auto',
          boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            position: 'sticky',
            top: 0,
            right: 0,
            zIndex: 10,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 24px',
            background: 'white',
            borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px',
          }}
        >
          <h2 style={{
            margin: 0,
            fontSize: '24px',
            color: 'black',
          }}>
            {editCard.fullname || editCard.business || 'Profile'}
          </h2>

          <button
            onClick={closeModal}
            style={{
              background: 'rgba(0,0,0,0.07)',
              border: 'none',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              fontSize: '28px',
              lineHeight: 1,
              color: '#444',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.18s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(0,0,0,0.12)';
              e.currentTarget.style.transform = 'scale(1.08)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(0,0,0,0.07)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            ×
          </button>
        </div>

        <div style={{ padding: '20px 40px 40px 40px', flex: 1 }}>
          <div>
            <label htmlFor="company" style={{ color: 'black' }}>Company</label>
            <input
              id='company'
              type="text"
              style={{ color: "black", cursor: editCard.business.trim() && "not-allowed" }}
              value={company}
              onChange={(e) => { setCompany(e.target.value) }}
              placeholder='Acme Corporation'
              readOnly={editCard.business.trim()}
            />
          </div>

          <div style={{ marginTop: "20px" }}>
            <label htmlFor="website" style={{ color: 'black' }}>Website Url</label>
            <input
              id='website'
              type="text"
              style={{ color: "black", cursor: editCard.website_url.trim() && "not-allowed" }}
              value={websiteUrl}
              onChange={(e) => { setWebsiteUrl(e.target.value) }}
              placeholder='https://sample.com'
              readOnly={editCard.website_url.trim()}
            />
          </div>

          <div style={{ marginBottom: '30px', marginTop: "20px" }}>
            <h4 style={{
              marginBottom: '6px',
              fontSize: '16px',
              fontWeight: 600,
              color: 'black',
              textAlign: "center"
            }}>
              Profile Picture
            </h4>

            <div style={{
              width: '160px',
              height: '160px',
              margin: '0 auto 8px',
              borderRadius: '50%',
              overflow: 'hidden',
              border: '3px solid #e0e0e0',
              background: '#f8f9fa',
              boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            }}>
              {avatarPreview || editCard.avatar ? (
                <img
                  src={avatarPreview || editCard.avatar}
                  alt="Avatar preview"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <div style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#aaa',
                  fontSize: '14px',
                }}>
                  No image
                </div>
              )}
            </div>

            <div style={{ textAlign: 'center' }}>
              <label
                htmlFor="avatar-upload"
                style={{
                  display: 'inline-block',
                  padding: '10px 24px',
                  background: '#1976d2',
                  color: 'white',
                  borderRadius: '8px',
                  cursor: uploading ? 'not-allowed' : 'pointer',
                  fontWeight: 500,
                  transition: 'background 0.2s',
                  opacity: uploading ? 0.6 : 1,
                }}
              >
                {avatarFile ? 'Change Avatar' : 'Upload Avatar'}
              </label>
              <input
                id="avatar-upload"
                type="file"
                accept="image/*"
                onChange={handleAvatarChange}
                disabled={uploading}
                style={{ display: 'none' }}
              />
              {avatarFile && (
                <div style={{
                  marginTop: '10px',
                  fontSize: '14px',
                  color: '#555',
                  wordBreak: 'break-all',
                  padding: '0 10px'
                }}>
                  {avatarFile.name}
                </div>
              )}
            </div>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <h4 style={{
              marginBottom: '6px',
              fontSize: '16px',
              fontWeight: 600,
              color: 'black',
              textAlign: "center"
            }}>
              Company Logo
            </h4>

            <div style={{
              width: '220px',
              height: '100px',
              margin: '0 auto 12px',
              border: '2px dashed #d0d0d0',
              borderRadius: '12px',
              background: '#fafafa',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}>
              {logoPreview || editCard.logo ? (
                <img
                  src={logoPreview || editCard.logo}
                  alt="Logo preview"
                  style={{ maxWidth: '92%', maxHeight: '92%', objectFit: 'contain' }}
                />
              ) : (
                <span style={{ color: '#888', fontSize: '15px' }}>No logo selected</span>
              )}
            </div>

            <div style={{ textAlign: 'center' }}>
              <label
                htmlFor="logo-upload"
                style={{
                  display: 'inline-block',
                  padding: '10px 24px',
                  background: '#0288d1',
                  color: 'white',
                  borderRadius: '8px',
                  cursor: uploading ? 'not-allowed' : 'pointer',
                  fontWeight: 500,
                  transition: 'background 0.2s',
                  opacity: uploading ? 0.6 : 1,
                }}
              >
                {logoFile ? 'Change Logo' : 'Upload Logo'}
              </label>
              <input
                id="logo-upload"
                type="file"
                accept="image/*"
                onChange={handleLogoChange}
                disabled={uploading}
                style={{ display: 'none' }}
              />
              {logoFile && (
                <div style={{
                  marginTop: '10px',
                  fontSize: '14px',
                  color: '#555',
                  wordBreak: 'break-all',
                  padding: '0 10px'
                }}>
                  {logoFile.name}
                </div>
              )}
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              gap: '20px',
              justifyContent: 'center',
              marginTop: '32px',
              position: "sticky",
              bottom: 0,
              padding: "16px 0",
              background: "white",
              borderTop: '1px solid #eee',
              flexDirection: "column"
            }}
          >
            {message && (
              <div style={{
                marginTop: '24px',
                color: '#2e7d32',
                textAlign: 'center',
                fontWeight: 500,
              }}>
                {message}
              </div>
            )}
            {error && (
              <div style={{
                marginTop: '24px',
                color: '#c62828',
                textAlign: 'center',
                fontWeight: 500,
              }}>
                {error}
              </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'center', gap: "20px" }}>
              <button
                onClick={closeModal}
                disabled={uploading}
                style={{
                  color: "black",
                  padding: '14px 36px',
                  background: '#f5f5f5',
                  border: '1px solid #ddd',
                  borderRadius: '10px',
                  fontSize: '16px',
                  cursor: uploading ? 'not-allowed' : 'pointer',
                  opacity: uploading ? 0.7 : 1,
                }}
              >
                Cancel
              </button>

              <button
                onClick={handleSaveEdits}
                disabled={uploading || !hasChanges}
                style={{
                  padding: '14px 36px',
                  background: uploading || !hasChanges ? '#b0bec5' : '#1976d2',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  fontSize: '16px',
                  fontWeight: 500,
                  cursor: uploading || !hasChanges ? 'not-allowed' : 'pointer',
                  boxShadow: uploading || !hasChanges ? 'none' : '0 4px 12px rgba(25, 118, 210, 0.3)',
                }}
              >
                {uploading ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpdateAvatarLogo